import mobile from "./PickerSelectorMobile";
import desktop from "./PickerSelectorDesktop";
import { responsiveComponent } from "@/utils/components";

export default responsiveComponent({
  mobile,
  desktop,
});
